import { orderDetailsButtonSetStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsButtonSet";
import { summaryTableStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsSummaryTable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

orderDetailsButtonSetStyles.reorderButton = {
    mergeCss: true,
    css: css`
        display: flex;
        align-items: center;
    `,
};

orderDetailsButtonSetStyles.rmaButton = {
    buttonType: "solid",
    variant: "secondary",
};

orderDetailsButtonSetStyles.overflowMenu = {
    cssOverrides: {
        wrapper: css`
            span {
                color: #ffffff !important;
            }
            ul {
                background: #ffffff;
            }
        `,
    },
};

orderDetailsButtonSetStyles.buttonWrapper = {
    css: css`
        margin-left: 20px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                css`
                    margin-right: 12px;
                `,
                null,
                null,
            ])}
    `,
};

summaryTableStyles.orderLines = {
    gridContainer: {
        css: css`
            .card_container__wrapper {
                border-top: 1px solid ${getColor("common.border")};
                border-bottom: 1px solid ${getColor("common.border")};
            }
            .card_container__wrapper ~ .card_container__wrapper {
                border-top: none;
            }
        `,
    },
};
